$(document).on('turbolinks:load', function () {
  $('.carousel-inner .carousel-item:first').addClass('active');
});
